import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience } from "./isEnabledForFrontierCopilotAudience";

export function isCalendarInstructionsV1Enabled(mailboxInfo: MailboxInfo | undefined): boolean {
    return (isGlobalFeatureEnabled("cal-ai-enable-calendar-instructions-v1") ||
        isCalendarInstructionsV1FrontierEnabled(mailboxInfo));
}

export function isCalendarInstructionsV1FrontierEnabled(mailboxInfo: MailboxInfo | undefined): boolean {
    if (!mailboxInfo) {
        return false;
    }
    
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: "cal-ai-enable-calendar-instructions-v1-frontier-public",
        privateTapFlight: "cal-ai-enable-calendar-instructions-v1-frontier-private-tap",
        privateStagingFlight: "cal-ai-enable-calendar-instructions-v1-frontier-private-staging",
        privateInfluencerFlight: "cal-ai-enable-calendar-instructions-v1-frontier-private-influencer",
    });
}
